import { useCallback, useMemo } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

type QueryParams = Record<string, any>;

const extractSearchParams = (searchParams: URLSearchParams) => {
    // TODO: Fix any type
    const newState: any = {};

    searchParams.forEach((value, key) => {
        if (!newState[key]) {
            newState[key] = value;
        } else {
            if (!Array.isArray(newState[key])) {
                newState[key] = [newState[key]];
            }
            newState[key].push(value);
        }
    });
    return newState;
};

const useUrlState = (defaultState = null) => {
    const history = useHistory();
    const location = useLocation();

    const searchParams = new URLSearchParams(defaultState ? defaultState : location.search);
    const state = useMemo(() => extractSearchParams(searchParams), [searchParams]);

    const setSearchParams = useCallback(
        (params: QueryParams) => {
            if (location.pathname.startsWith('/deep-analysis')) {
                //console.log('setting params', params);
                let search = null;
                const searchParams = new URLSearchParams(params);

                if (Object.keys(params).length > 0) {
                    //console.log('params has keys');
                    search = '?' + searchParams.toString();
                    history.replace({ pathname: location.pathname, search: search });
                } else {
                    //console.log('params is empty    ');
                    history.replace({ pathname: location.pathname });
                }
            }
        },
        [history, location.pathname]
    );

    return [state, setSearchParams];
};

export default useUrlState;
